import { Grid } from "@mui/material";
import { parseWithOptions } from "date-fns/fp";
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import PSelect from "../../components/pos/PSelect";
import API from "../../utils/API";
import { SaleUtils } from "../../utils/SaleUtils";

export default function ServiceUpdate(props) {
  const [srAssignee, setSrAssignee] = useState(null);
  const [srStatus, setSrStatus] = useState(null);

  const [srNote, setSrNode] = useState("");
  const { t, i18n } = useTranslation();
  const translate = t;

  useEffect(() => {
    if (props.serviceBean) {
      if (props.serviceBean.assigned) {
        setSrStatus(
          SaleUtils.getOption(
            props.statusOptions,
            props.serviceBean.serviceStatus
          )
        );
        setSrAssignee(
          SaleUtils.getOption3(props.userOptions, props.serviceBean.assigned)
        );
      }
    }
  }, [props.serviceBean]);

  async function onSave() {
    let payload = {};
    if (srAssignee) {
      payload["assigned"] = srAssignee.name;
    }
    if (srStatus) {
      payload["serviceStatus"] = srStatus.id;
    }
    try {
      let result = await API.put(
        "/api/v1/service/" + props.serviceBean.id,
        payload
      );
      props.showMessage("success", "Service Updated");
      props.handleHistorySearch();
      props.setShowServiceUpdateWindow(false);
    } catch (err) {
      props.showMessage("error", "Not able to update Service");
    }
  }

  return (
    <MScreen
      title={props.serviceBean ? props.serviceBean.invoiceNo : "Service"}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => {
        props.setServiceBean(null);
        props.setShowServiceUpdateWindow(false);
      }}
      onRedirectToHome={() => props.setCurrentPage("home")}
      onLogOut={props.onLogOut}
      dialogMode={true}
      maxWidth={"xs"}
      position={props.context.appMode === "desktop-pos" ? "static" : "fixed"}
      rightAction={translate("Update")}
      onRightAction={() => {
        onSave();
      }}
      enbaleRightAction={true}
      content={
        <Grid container style={{ padding: 5 }}>
          <Grid item xs={3} style={{ paddingTop: 5 }}>
            {props.srAssigneeLabel}
          </Grid>
          <Grid item xs={9}>
            <PSelect
              options={props.userOptions}
              value={srAssignee}
              onChange={(event, newValue) => {
                setSrAssignee(newValue);
              }}
            >
              Select
            </PSelect>
          </Grid>
          {props.serviceBean && props.serviceBean.serviceStatus != "CLOSED" && (
            <Grid item xs={3} style={{ paddingTop: 10, marginTop: 5 }}>
              {"Status"}
            </Grid>
          )}
          {props.serviceBean && props.serviceBean.serviceStatus != "CLOSED" && (
            <Grid item xs={9} style={{ paddingTop: 5, marginTop: 5 }}>
              <PSelect
                options={props.statusOptions}
                value={srStatus}
                onChange={(event, newValue) => {
                  setSrStatus(newValue);
                }}
              >
                Select
              </PSelect>
            </Grid>
          )}
        </Grid>
      }
    ></MScreen>
  );
}
